import { DataCell } from "../atoms/DataCell";
import { STYLES } from "../../config/styles";

interface TextCellProps {
  value: string | undefined;
  muted?: boolean;
  fallback?: string;
  italic?: boolean;
}

export function TextCell({ value, muted = false, fallback = "—", italic = false }: TextCellProps) {
  return (
    <td className={STYLES.table.cellPadding}>
      <DataCell muted={muted || !value} className={italic ? "italic" : ""}>
        {value || fallback}
      </DataCell>
    </td>
  );
}
